import { atom, useAtom } from 'jotai';
import { cx } from '@emotion/css';
import { HTMLAttributes } from 'react';
import { ArrowsAltOutlined, ShrinkOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';

export const collapseOperationState = atom<Status>('fold');

type Status = 'fold' | 'unfold';
interface CollapseOperationProps extends HTMLAttributes<HTMLDivElement> {
  status: Status;
  setStatus: (s: Status) => void;
}
// 展开折叠操作，纯视图
export const CollapseOperation = (props: CollapseOperationProps) => {
  const { className, status, setStatus, ...rest } = props;
  const { t } = useTranslate();
  return (
    <div className={cx('text-[#515359] hover:text-[#3366ff]', className)} {...rest}>
      {status === 'unfold' ? (
        <div className="cursor-pointer" onClick={() => setStatus('fold')}>
          <ShrinkOutlined className="mr-[4px]" />
          {t('single_fold_sku')}
        </div>
      ) : (
        <div className="cursor-pointer" onClick={() => setStatus('unfold')}>
          <ArrowsAltOutlined className="mr-[4px]" />
          {t('single_unfold_sku')}
        </div>
      )}
    </div>
  );
};

export const CollapseOperationInSingleClassNew = (
  props: Omit<CollapseOperationProps, 'status' | 'setStatus'>,
) => {
  const [status, setStatus] = useAtom(collapseOperationState);
  return <CollapseOperation status={status} setStatus={setStatus} {...props} />;
};
